import React, { InputHTMLAttributes } from "react";
import styled from "styled-components";

const Container = styled.div`
  --radio-checked-color: var(--sea);
  --radio-border-color: var(--sand);

  --radio-size: 20px;
  --radio-checked-size: 10px;

  // modern replacement for 'position: absolute' - all children positioned into the same cell
  display: grid;
  grid-template-areas: "checkbox";
  > * {
    grid-area: checkbox;
  }

  margin-right: 6px;
`;

const NativeRadio = styled.input`
  opacity: 0;
  width: var(--radio-size);
  height: var(--radio-size);
`;

const Circle = styled.div`
  border-radius: 50%;

  transition: all 0.3s ease;
  transition-property: transform, border-color;

  pointer-events: none;
`;

const OuterCircle = styled(Circle)`
  width: var(--radio-size);
  height: var(--radio-size);

  display: grid;
  justify-content: center;
  align-content: center;

  border: 2px solid var(--radio-border-color);

  ${NativeRadio}:checked + & {
    border-color: var(--radio-checked-color);
  }
`;

const InnerCircle = styled(Circle)`
  width: var(--radio-checked-size);
  height: var(--radio-checked-size);
  background: var(--radio-checked-color);

  transform: scale(0);

  ${NativeRadio}:checked + ${OuterCircle} & {
    transform: scale(1);
  }
`;

type Props = {
  id?: string;
  onChange?: React.ChangeEventHandler;
  value: string;
  name?: string;
  checked?: boolean;
} & InputHTMLAttributes<HTMLInputElement>;

// N.B. currently no error state styles (as haven't needed them yet)
// N.B. using tabIndex={-1} instead of focusable={false}
const RadioButton = ({
  id = undefined,
  onChange = undefined,
  value,
  name = undefined,
  checked = undefined,
  className = undefined,
  ...props
}: Props) => (
  <Container className={className}>
    <NativeRadio
      id={id}
      onChange={onChange}
      value={value}
      name={name}
      type="radio"
      checked={checked}
      {...props}
    />
    <OuterCircle aria-hidden="true" tabIndex={-1}>
      <InnerCircle aria-hidden="true" tabIndex={-1} />
    </OuterCircle>
  </Container>
);

export default RadioButton;
